import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {},
    form: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',
      gap: '1rem',
      '& > button': {
        flex: 1
      },
      marginTop: '1rem'
    },
    inputs: {
      width: '100%',
      display: 'flex',
      flexWrap: 'wrap',
      gap: '1rem',
      justifyContent: 'space-between',
      alignItems: 'stretch',
      '& > *': {
        flex: 1
      }
    },
    actions: {
      display: 'flex',
      justifyContent: 'flex-end',
      gap: '10px'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
